import { useRef, useState, useEffect } from 'react';
import DateTime from '../fragments/DateTime';
import { useGetLocation, getDistanceFromLatLonInKm } from '../../hooks/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { getLocationsByLatLng, getLocationsByLatLngWithDate } from '../../scripts/fetchApi';
import { variousActions } from '../../store/various';
import { locationActions } from '../../store/location';

import LocationPin from '../../icons/locationpin';
import SearchIcon from '../../icons/searchicon';
import NoDeliveryIcon from '../../icons/nodeliveryicon';
import AddressInput from './AddressInput';
import DeliverySetDetailsSimplyfied from './DeliverySetDetailsSimplyfied';
import classes from './DeliveryPannel.module.css'
import GetCurrentLocation from './GetCurrentLocation';
import AutocompleteComponent from './AutocompleteComponent';


const DeliveryPannel = ({switchToPickup}) => {
    const deliveryType = 'dispatch' // former delivery?dispatch
    const dispatch = useDispatch()
    const [locationBlocked, setLocationBlocked] = useState(false)

    const [noLocation, setNoLocation] = useState(false)
    const [loading, setLoading] = useState(false)
    const [foundLocations, setFoundLocations] = useState(null)
    const [searchedLocations, setSearchedLocation] = useState(null)
    const [inputValue, setInputValue] = useState('')

    const [inputError, setInputError] = useState({
        hasErrors: false,
        errorMessage: null
    })

    let orderType = useSelector(state => state.location.order)
    let time = useSelector(state => state.location.order)


    useEffect(() => {
        if (orderType.type === 'schedule') {

            if (orderType.date !== null && orderType.time !== null) {
                setLocationBlocked(false)
            } else {
                setLocationBlocked(true)
            }
            
        } else {
            setLocationBlocked(false)
        }
    }, [orderType]) 

    const selectedResultHandler = async (address) => {
        if (address) {
            setLoading(true)
            // setSearchedLocation(searchedLocations)
            const loc = await getLocationsByLatLng({
                lat: address.latitude,
                lng: address.longitude
            }, 'pickup')

            if (loc.message) {
                setNoLocation(true)
                setFoundLocations(null)
            } else {
                setFoundLocations(loc)
                setNoLocation(false)
            }

            setLoading(false)
        } else {
            dispatch(variousActions.setError({message: 'Please select an address'}))
        }
    }

    const pickupPannelHandler = () => {        
        // dispatch(locationActions.setVirtualDeliveryType('pickup'))
        switchToPickup()
    }
  

    const setErrorAddress = (data) => {
        if (data) {
            setInputError({
                hasErrors: true,
                errorMessage: data
            })      
        } else {
            setInputError({
                hasErrors: false,
                errorMessage: null
            })
        }
    }

    return <>
        {!foundLocations && <div className='form-fields-container'>
            <DateTime />
            <div className={`form-controller ${locationBlocked && 'invalid'}`}>
                {/* <GetCurrentLocation deliveryType={'pickup'} foundLocations={(loc) => {setFoundLocations(loc)}} noLocation={() => {setNoLocation(true)}}/> */}
                <AddressInput label={'Enter your address'} selectedResult={selectedResultHandler} loading={loading} foundLocations={(loc) => {setFoundLocations(loc)}} setError={setErrorAddress} setValue={(value) => {setInputValue(value)}} setAddressDetails={(data) => {setSearchedLocation(data)}} inputError={inputError.hasErrors}/>
                {inputError.hasErrors && <div className='error-message'>{inputError.errorMessage}</div>}
            </div>
        </div>}
        
        
        {noLocation && <div className={`${classes.text_info} ${classes.no_delivery_text}`}>
            <NoDeliveryIcon />
            <h4>Delivery isn’t available in your area.</h4>
            <p>We're sorry, no locations currently deliver to this address.</p>
            <div className={classes.cta_container}>
                <button className='btn-underline' onClick={pickupPannelHandler}>Search Pickup Options</button>
            </div>
        </div>}    


        {!noLocation && !foundLocations && <div className={classes.delivery_description_text}>
            <div className={classes.text_info}>
                <svg width="56" height="70" viewBox="0 0 56 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M24.7318 66.6626C-37.4594 14.3665 35 -22.4885 53.5914 15.8259C58.7506 29.3444 52.5063 43.6053 43.2411 53.6283C42.0958 55.0151 40.9265 56.3766 39.7599 57.7348C36.8405 61.134 33.9387 64.5127 31.4747 68.2157C30.5545 69.7334 28.6648 69.339 27.1765 69.0284C27.0296 68.9977 26.8866 68.9679 26.7488 68.9408C26.0301 68.2624 25.3506 67.4494 24.7318 66.6626ZM39.6164 27.5192L35.7429 26.7409L36.9215 30.347L39.6164 27.5192ZM30.8511 35.6135L33.6179 36.7862L34.8685 34.1918L32.1017 33.0192L30.8511 35.6135ZM25.3175 25.6253L26.4242 28.8682L29.8827 27.8305L28.776 24.5875L25.3175 25.6253ZM22.9546 31.4263L22.4012 35.1206L26.1198 33.7767L22.9546 31.4263ZM23.1704 21.1682L25.5001 17.4479L21.0676 17.5361L23.1704 21.1682ZM14.8755 28.4064L15.9822 31.6494L19.4407 30.6064L18.334 27.3687L14.8755 28.4064ZM44.3001 28.1396C44.4067 28.8054 44.4435 29.0354 43.8497 30.8659V30.9489C43.709 31.3808 43.769 31.8386 43.829 32.2957C43.8894 32.7557 43.9497 33.215 43.8054 33.647C43.6993 33.9587 43.526 34.2466 43.2963 34.4928H43.3682C41.7189 37.4523 39.1165 39.849 35.931 41.3419C35.1466 41.4487 34.3577 41.4947 33.5705 41.5405C32.4084 41.6082 31.25 41.6756 30.1151 41.9386C29.5885 42.0615 29.0577 42.2296 28.5229 42.399C27.8157 42.623 27.1014 42.8493 26.3799 42.9763C23.4715 42.6898 20.69 41.709 18.3008 40.1277C18.0864 39.4229 17.9638 38.6964 17.9356 37.964C17.9246 37.759 17.8457 37.5623 17.7098 37.4014C17.5739 37.2405 17.3878 37.1234 17.1775 37.0664C16.152 36.8318 15.16 36.4834 14.2225 36.0286C14.1335 35.9886 14.0382 35.9623 13.9403 35.9508C12.2883 33.6313 11.3064 30.9496 11.0905 28.1677C11.36 28.1681 11.6194 28.0714 11.815 27.8976C12.0107 27.7238 12.1277 27.4861 12.1419 27.2338C12.2748 24.5326 12.6094 21.8434 13.1434 19.1861C13.8938 17.9121 14.8245 16.7392 15.9103 15.6993C18.6328 13.0842 22.6669 10.8945 26.6732 11.2578C27.0955 11.2958 27.5383 11.3569 27.9916 11.4194C28.7143 11.5192 29.4636 11.6226 30.1981 11.6417C30.3977 11.6448 30.5179 11.5101 30.632 11.3823C30.711 11.2938 30.787 11.2087 30.8843 11.1747C31.2832 11.0624 31.7084 11.0624 32.1073 11.1747C33.1642 11.403 34.7136 11.7455 34.7579 12.5861C34.6712 12.7477 34.5531 12.932 34.4207 13.1387C33.826 14.0672 32.9415 15.4481 33.3081 17.2559C33.5681 18.5375 34.0994 19.9021 35.4551 20.1771C35.6875 20.2238 36.8275 21.0385 36.8994 21.7078C36.9324 22.0355 37.15 22.214 37.3837 22.4057C37.5423 22.5358 37.7083 22.6719 37.829 22.8649C38.2726 23.5204 38.9396 24.016 39.7216 24.271C40.4997 24.5189 41.3128 24.657 42.1342 24.6809C43.0694 24.738 43.6947 24.9663 44.0433 25.7187C44.1281 25.8925 44.1661 26.0831 44.154 26.2739C44.1599 27.2642 44.2408 27.7693 44.3001 28.1396Z" fill="var(--color-dark-raspberry)"/>
                </svg>
                <h4>Just Need Your Address</h4>
                <p>Let’s see if you can get all your favorite sweet treats delivered straight to your door.</p>
            </div>

            
        </div>}


        {!noLocation && foundLocations && foundLocations.length> 0 && 
            // <DeliverySetDetails orderType={orderType} searchedLocations={searchedLocations} foundLocation={foundLocations[0]} deliveryType={deliveryType} time={time}/>
            <DeliverySetDetailsSimplyfied orderType={orderType} searchedLocations={searchedLocations} foundLocation={foundLocations[0]} deliveryType={deliveryType} time={time} />
        }
           
    </>
}

export default DeliveryPannel